import { render, staticRenderFns } from "./OptionArticleItem.vue?vue&type=template&id=096ec13e&scoped=true"
import script from "./OptionArticleItem.vue?vue&type=script&lang=ts"
export * from "./OptionArticleItem.vue?vue&type=script&lang=ts"
import style0 from "./OptionArticleItem.vue?vue&type=style&index=0&id=096ec13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096ec13e",
  null
  
)

export default component.exports